import { render, staticRenderFns } from "./TechnicalInvoicePage.vue?vue&type=template&id=a8048594&scoped=true&"
import script from "./TechnicalInvoicePage.vue?vue&type=script&lang=ts&"
export * from "./TechnicalInvoicePage.vue?vue&type=script&lang=ts&"
import style0 from "./TechnicalInvoicePage.vue?vue&type=style&index=0&id=a8048594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8048594",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
